import { useState } from 'react';

const plans = [
  {
    name: 'スターター',
    price: '無料',
    priceNote: '成果報酬10%',
    desc: 'はじめての店舗に最適',
    popular: false,
    features: [
      'QRコード 1枚発行',
      '月間スキャン数 500回まで',
      '基本レポート機能',
      'メールサポート',
      '成果確認ダッシュボード',
    ],
    notIncluded: ['カスタムデザインQR', 'A/Bテスト機能', '専任担当者'],
    cta: '無料で始める',
  },
  {
    name: 'スタンダード',
    price: '¥9,800',
    priceNote: '/月 + 成果報酬7%',
    desc: '成長中の店舗・中規模事業者向け',
    popular: true,
    features: [
      'QRコード 10枚発行',
      '月間スキャン数 無制限',
      '詳細レポート + CSV出力',
      'チャット・電話サポート',
      'カスタムデザインQR',
      'A/Bテスト機能',
      'アフィリエイター自動マッチング',
    ],
    notIncluded: ['専任担当者'],
    cta: '14日間無料トライアル',
  },
  {
    name: 'エンタープライズ',
    price: '要見積',
    priceNote: '成果報酬カスタム',
    desc: '大型チェーン・複数店舗展開向け',
    popular: false,
    features: [
      'QRコード 無制限発行',
      '月間スキャン数 無制限',
      'カスタムレポート・API連携',
      '24時間専任サポート',
      '専任アカウントマネージャー',
      'SLA保証',
      'セキュリティ監査対応',
      'ホワイトラベル提供',
    ],
    notIncluded: [],
    cta: '詳細を相談する',
  },
];

export default function Pricing() {
  const [annual, setAnnual] = useState(false);

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-red-500 text-sm font-bold tracking-widest uppercase">Pricing</span>
          <h2 className="text-4xl font-black text-gray-900 mt-3 mb-4">料金プラン</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            初期費用は一切かかりません。規模やニーズに合わせてお選びください。
          </p>
          <div className="inline-flex items-center gap-1 bg-gray-100 p-1 rounded-full mt-6">
            <button
              onClick={() => setAnnual(false)}
              className={`cursor-pointer whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all ${!annual ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'}`}
            >
              月払い
            </button>
            <button
              onClick={() => setAnnual(true)}
              className={`cursor-pointer whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all ${annual ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'}`}
            >
              年払い <span className="text-red-500 text-xs ml-1">20%OFF</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, i) => (
            <div
              key={i}
              className={`rounded-xl border-2 p-8 flex flex-col relative ${plan.popular ? 'border-red-400 bg-red-50' : 'border-gray-100 bg-white'}`}
            >
              {plan.popular && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="bg-red-500 text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                    人気No.1
                  </span>
                </div>
              )}
              <div className="mb-6">
                <div className={`text-sm font-bold mb-1 ${plan.popular ? 'text-red-500' : 'text-gray-500'}`}>
                  {plan.name}
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="text-3xl font-black text-gray-900">
                    {annual && plan.price !== '無料' && plan.price !== '要見積'
                      ? `¥${Math.floor(9800 * 0.8).toLocaleString()}`
                      : plan.price}
                  </span>
                  <span className="text-gray-400 text-sm">{plan.priceNote}</span>
                </div>
                <div className="text-gray-400 text-xs mt-1">{plan.desc}</div>
              </div>

              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className={`cursor-pointer whitespace-nowrap w-full py-3 rounded-md text-sm font-bold mb-7 transition-colors ${plan.popular ? 'bg-red-500 text-white hover:bg-red-600' : 'bg-gray-900 text-white hover:bg-gray-800'}`}
              >
                {plan.cta}
              </button>

              <ul className="flex flex-col gap-3 flex-1">
                {plan.features.map((f, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-green-500 flex-shrink-0 mt-0.5"></i>
                    {f}
                  </li>
                ))}
                {plan.notIncluded.map((f, j) => (
                  <li key={`no-${j}`} className="flex items-start gap-2 text-sm text-gray-400">
                    <i className="ri-close-line text-gray-300 flex-shrink-0 mt-0.5"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-xs mt-8">
          ※ 全プラン初期費用0円。成果報酬は成果確定時のみ発生します。消費税別途。
        </p>
      </div>
    </section>
  );
}
